import api from "@/configs/axios-config";

export const getMe = async () => {
  const res = await api.get("/permission-management/users/me/");
  return res.data;
};

export type UserWithPermission = {
  user_id: string;
  name: string;
  lastname: string;
  full_name: string;
  email: string;
  status: string;
  division: string;
  department: string;
  updated_at: string;
  updated_by: string;
  user_groups: string[];
  group_permissions: string[];
  direct_permissions: string[];
  user_image: string | null;
  buyer_code: string | null;
};

export const getUsersPermission = async (): Promise<UserWithPermission[]> => {
  const params = {
    skip: 0,
    limit: Number.MAX_SAFE_INTEGER,
  };

  const res = await api.get("/permission-management/users-with-permissions/", {
    params,
  });
  return res.data.users;
};

export type UpdateUserParams = {
  user_id: string;
  is_active: boolean;
  groups: number[];
}

export const updateUser = async (params: UpdateUserParams) => {
  const res = await api.post(`/permission-management/update-user/`, params);
  return res.data;
};

export type User = {
  user_id: string;
  email: string;
  name: string;
  lastname: string;
  position_id: string;
  devision: string;
  department: string;
  section: string;
  plant: string;
  buyer_code: string | null;
};

export const getAllUsers = async (): Promise<User[]> => {
  const res = await api.get("/permission-management/users/all/");
  return res.data;
};

export const createUser = async (userId: string, groupIds: number[]) => {
  const res = await api.post("/permission-management/create-user/", {
    user_id: userId,
    groups: groupIds,
  });
  return res.data;
};

